export default ({ request }) => ({
  techDocListApi(data = {}) {
    return request({
      url: '/factory/tech/doc/list',
      method: 'post',
      data,
    })
  },
  techDocDetailApi(data = {}) {
    return request({
      url: '/factory/tech/doc/detail',
      method: 'post',
      data,
    })
  },
  techDocBatchUploadApi(data = {}) {
    return request({
      url: '/factory/tech/doc/batch/upload',
      method: 'post',
      data,
    })
  },
  techDocDelApi(data = {}) {
    return request({
      url: '/factory/tech/doc/del',
      method: 'post',
      data,
    })
  },
})
